export default "__VITE_ASSET__CFd1fWDn__"